import type { SignatureLayout } from '../../../types/facility.type'
import type { ReactNode } from 'react'

type ReportSignatureBlockProps = {
  layout: SignatureLayout
  stampUrl?: string
  /** Signature pad (fill) or rendered signature HTML (snapshot). */
  signatureSlot: ReactNode
  className?: string
}

function Stamp({ src }: { src: string }) {
  return (
    <img
      alt="Approved stamp"
      className="h-[100px] w-[200px] shrink-0 object-contain print:h-[70px] print:w-[140px]"
      height={100}
      src={src}
      width={200}
    />
  )
}

const ReportSignatureBlock = ({ layout, stampUrl, signatureSlot, className = '' }: ReportSignatureBlockProps) => {
  if (layout === 'center') {
    return (
      <div className={`flex flex-col items-center gap-6 print:gap-3 ${className}`}>
        <div className="w-full max-w-md">{signatureSlot}</div>
        {stampUrl ? <Stamp src={stampUrl} /> : null}
      </div>
    )
  }

  if (layout === 'left') {
    // Signature left, stamp right — bottom-aligned so stamp sits with the signature line
    return (
      <div className={`flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between print:gap-3 ${className}`}>
        <div className="w-full max-w-md shrink-0">{signatureSlot}</div>
        {stampUrl ? <Stamp src={stampUrl} /> : null}
      </div>
    )
  }

  // right (default): stamp left, signature right — slight lift so role title sits higher vs stamp
  return (
    <div className={`flex flex-col-reverse gap-6 sm:flex-row sm:items-end sm:justify-between print:gap-3 ${className}`}>
      {stampUrl ? (
        <Stamp src={stampUrl} />
      ) : (
        <div aria-hidden className="hidden h-[100px] w-[200px] sm:block print:h-[70px] print:w-[140px]" />
      )}
      <div className="w-full max-w-md shrink-0 sm:mb-5 sm:ml-auto print:mb-3">{signatureSlot}</div>
    </div>
  )
}

export default ReportSignatureBlock
